import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {alias, custom, serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

const typeModelSchema = alias(
    Type.TYPE_KEY,
    custom(
        function(type:Type)
        {
            return type && type.kind && type.kind.toUpperCase();
        },
        function(jsonValue:any,
                 context?,
                 currentPropertyValue?)
        {
            return currentPropertyValue;
        }
    )
);

export abstract class BaseValue implements IValue
{
    @serializable(typeModelSchema)
    public readonly type:Type;

    public constructor(type:Type)
    {
        this.type = type;
    }

    public get isError():boolean
    {
        return this.type === Type.Error;
    }

    public get isEmpty():boolean
    {
        return this.type === Type.Empty;
    }

    public get isFrame():boolean
    {
        return this.type === Type.Frame;
    }

    getType():Type
    {
        return this.type;
    }

    public get kind():string
    {
        return this.type.kind;
    }

    public abstract toString():string;

    public abstract toValue():string;

    public abstract isEqualTo(other:IValue):boolean;

    public abstract compareTo(other:IValue):number;

    public abstract clone():IValue;

    public static __deserializing:boolean = false;

    public static isSkipValidation<T extends BaseValue>(clazz:{new(...args):T}):boolean
    {
        if( clazz && (clazz as any).__deserializing )
            return true;

        return false;
    }

    public static isValueEmpty(value:IValue):boolean
    {
        return !!(!value
            || Type.isInstanceOf(value, Type.Empty)
            || (Type.isInstanceOf(value, Type.String)
                && (value as any).value != null
                && (value as any).value.length === 0));
    }
}
